import { Sprout } from 'lucide-react';

/**
 * Step 0: Intro / context splash.
 *
 * A centered welcome that frames the flow ("Add seeds to your attack surface")
 * before the user makes their first decision. Ported from the Hannibal
 * `LaunchHannibalDialog` intro feel (centered, fixed `h-[600px]` height handled
 * by the modal). The welcome copy here is the seam the `NewUserSeedModal`
 * onboarding flow reuses in Batch D, so first-run users and returning users see
 * the same opening screen.
 *
 * Always advanceable (`validate: () => true` in wizardConfig) — the intro never
 * blocks forward navigation.
 */
export const IntroStep = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center">
      <span className="bg-chariot-background-secondary flex size-16 items-center justify-center rounded-full">
        <Sprout
          aria-hidden="true"
          className="text-chariot-brand-primary size-8"
        />
      </span>
      <div className="flex flex-col gap-2">
        <h3 className="text-chariot-text-primary text-xl font-semibold">
          Add seeds to your attack surface
        </h3>
        <p className="text-chariot-text-secondary mx-auto max-w-md text-sm leading-relaxed">
          Seeds are the starting points Guard scans from — domains, IP ranges,
          web applications, and web services. Add a few and Guard will discover
          the assets, exposures, and risks connected to them.
        </p>
      </div>
    </div>
  );
};
